"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _migrateDeprecatedProps = _interopRequireDefault(require("./migrateDeprecatedProps"));

var _Say = _interopRequireDefault(require("./Say"));

var SayButton = function SayButton(props) {
  var _migrateDeprecatedPro = (0, _migrateDeprecatedProps["default"])(props, SayButton),
      children = _migrateDeprecatedPro.children,
      disabled = _migrateDeprecatedPro.disabled,
      lang = _migrateDeprecatedPro.lang,
      onBoundary = _migrateDeprecatedPro.onBoundary,
      _onEnd = _migrateDeprecatedPro.onEnd,
      onError = _migrateDeprecatedPro.onError,
      onStart = _migrateDeprecatedPro.onStart,
      pitch = _migrateDeprecatedPro.pitch,
      ponyfill = _migrateDeprecatedPro.ponyfill,
      rate = _migrateDeprecatedPro.rate,
      text = _migrateDeprecatedPro.text,
      voice = _migrateDeprecatedPro.voice,
      volume = _migrateDeprecatedPro.volume;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      busy = _useState2[0],
      setBusy = _useState2[1];

  var handleClick = (0, _react.useCallback)(function () {
    return setBusy(true);
  });
  var sayProps = {
    lang: lang,
    onBoundary: onBoundary,
    onEnd: function onEnd(event) {
      setBusy(false);
      _onEnd && _onEnd(event);
    },
    onError: onError,
    onStart: onStart,
    pitch: pitch,
    ponyfill: ponyfill,
    rate: rate,
    text: text,
    voice: voice,
    volume: volume
  };
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("button", {
    disabled: typeof disabled === 'boolean' ? disabled : busy,
    onClick: handleClick
  }, children), busy && _react["default"].createElement(_Say["default"], sayProps));
};

SayButton.defaultProps = {
  children: undefined,
  disabled: undefined,
  lang: undefined,
  onBoundary: undefined,
  onEnd: undefined,
  onError: undefined,
  onStart: undefined,
  pitch: undefined,
  ponyfill: undefined,
  rate: undefined,
  text: undefined,
  voice: undefined,
  volume: undefined
};
SayButton.propTypes = {
  children: _propTypes["default"].any,
  disabled: _propTypes["default"].bool,
  lang: _propTypes["default"].string,
  onBoundary: _propTypes["default"].func,
  onEnd: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  onStart: _propTypes["default"].func,
  pitch: _propTypes["default"].number,
  ponyfill: _propTypes["default"].shape({
    speechSynthesis: _propTypes["default"].any.isRequired,
    SpeechSynthesisUtterance: _propTypes["default"].any.isRequired
  }),
  rate: _propTypes["default"].number,
  text: _propTypes["default"].string,
  voice: _propTypes["default"].oneOfType([_propTypes["default"].any, _propTypes["default"].func]),
  volume: _propTypes["default"].number
};
var _default = SayButton;
exports["default"] = _default;